/**
 * @param {string} groupName
 * @param cb
 * @param {'danger'|'primary'|'success'|'warning' |'info'} color
 */
const logging = (groupName = 'Logging', cb, color = 'primary') => {
	// if (MIX_PRODUCTION) {
	// 	return;
	// }

	if (typeof groupName !== 'string') {
		throw new Error('groupName must be a string');
	}

	if (typeof cb !== 'function') {
		throw new Error('cb must be a function');
	}

	const styles = new Map();

	styles.set('danger', 'rgb(220, 53, 69)');
	styles.set('primary', 'rgb(13, 110, 253)');
	styles.set('success', 'rgb(25, 135, 84)');
	styles.set('warning', 'rgb(255, 193, 7)');
	styles.set('info', 'rgb(13, 202, 240)');

	const bgColor = styles.get(color) || styles.get('primary');

	console.group(
		`%cHOF:${groupName}`,
		`background-color: ${bgColor}; color: white; padding: 5px 10px; font-weight: bold;`
	);

	cb();
	console.groupEnd();
};

export default logging;
